/*
 * Rotating brand quotes.
 *
 * Cross-fades between quotes and keeps the dots in step. Pauses on hover and
 * focus, and does not rotate at all when the visitor prefers reduced motion —
 * text that moves on its own is hard to read for some people.
 */
class LusheQuotes extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-quote]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    if (this.items.length < 2) return;

    this.index = 0;
    this.interval = (parseInt(this.dataset.interval, 10) || 7) * 1000;
    this.allowAuto =
      this.dataset.auto !== 'false' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.dots.forEach((dot, i) =>
      dot.addEventListener('click', () => {
        this.show(i);
        this.restart();
      })
    );

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  show(next) {
    this.items[this.index].classList.remove('is-active');
    this.items[this.index].setAttribute('aria-hidden', 'true');
    this.dots[this.index]?.classList.remove('is-active');
    this.dots[this.index]?.setAttribute('aria-selected', 'false');

    this.index = (next + this.items.length) % this.items.length;

    this.items[this.index].classList.add('is-active');
    this.items[this.index].removeAttribute('aria-hidden');
    this.dots[this.index]?.classList.add('is-active');
    this.dots[this.index]?.setAttribute('aria-selected', 'true');
  }

  start() {
    if (!this.allowAuto || this.timer) return;
    this.timer = setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

customElements.define('lushe-quotes', LusheQuotes);
